module.exports = __webpack_public_path__ + "static/media/image.ff513364.svg";